<template>
    <label
        class="mds-form__checkbox"
        :class="{ 'mds-form__checkbox--hide-label': !hasText}"
    >
        <input
            ref="input"
            type="checkbox"
            class="mds-form__checkbox-input"
            name="checkbox-name"
            :indeterminate="indeterminate"
            :value="value"
            :checked="checked"
            @change="$emit('change', $event.target.checked, $event.target.checked ? value : null)"
        >
        <span class="mds-form__checkbox-visible-wrap">
            <span class="mds-form__checkbox-visual">
                <svg
                    class="mds-icon mds-form__checkbox-checked-icon"
                    name="check--s"
                    aria-hidden="true"
                >
                    <use xlink:href="static/mds/icons/mds.svg#check--s"> </use>
                </svg>
                <svg
                    class="mds-icon mds-form__checkbox-indeterminate-icon"
                    name="minus--s"
                    aria-hidden="true"
                >
                    <use xlink:href="static/mds/icons/mds.svg#minus--s"> </use>
                </svg>
            </span>
            <span class="mds-form__checkbox-text">
                <slot>{{ text }}</slot>
            </span>
        </span>
    </label>
</template>

<script>
/*
 * This component is from Cloud Platform Modules
 * https://msstash.morningstar.com/projects/DIRECTPL/repos/cloud-platform-modules
 */
import { isDef } from '@/utils';

export default {
  name: 'pending-check-box',
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    checked: Boolean,
    value: { type: [Object, String, Boolean, Array, Number], default: null },
    text: { type: String, default: '' },
    indeterminate: Boolean,
  },
  computed: {
    hasText() {
      const { text, $slots } = this;
      return (isDef(text) && text !== '') || $slots.default;
    },
  },
  watch: {
    indeterminate() {
      this.$refs.input.indeterminate = this.indeterminate;
    },
  },
  mounted() {
    this.$refs.input.indeterminate = this.indeterminate;
  },
};
</script>
